import styled from "styled-components"
import { useAuthorisedValuesCategory } from "../../controllers/AuthorisedValuesCategoryController";
import { Row, Col, Button, setParamsFilter, Typography } from '../../../ui/ot'
import { useRef } from "react";
import { Link, useNavigate } from 'react-router-dom'
import ProTableOt from "../../../utility/componentOt/views/ProtableOt"
import { useProTableOt } from '../../../utility/componentOt/controllers/ProtableOtController'
import ReactHtmlParser from 'react-html-parser';
import { useTranslation } from "react-i18next";

const AuthorisedValues = ({
    title,
    keyPrefix = 'library.backstage.authorized_values_management'
}) => {
    const { t } = useTranslation('translation', { keyPrefix })
    const navigate = useNavigate()
    const actionRef = useRef()
    const columns = [
        {
            title: t('category'),
            dataIndex: 'category',
             key: 'category',
            sorter: true,
            render: (text, record, index) => {
                return <div>
                    <Link to={'/library/backstage/authorized_values_management/' + record?.category} style={{ color: 'blue', fontWeight: 'bold' }}>{record?.category}</Link>
                </div>
            }
        },
        {
            title: t('description'),
            dataIndex: 'description',
             key: 'description',
            sorter: true,
            ellipsis: true,
            width: 500,
            render: (text, record, index) => {
                return <div style={{ whiteSpace: "break-spaces"} }>
                    {ReactHtmlParser(record?.description)}
                </div>
            }
        },
        {
            title: '',
            key: 'option', valueType: 'option',
            render: (text, record, index) => {
                return <>
                    <Typography.P><Button variant="ghost" onClick={() => { navigate(`/library/backstage/authorized_values_management/${record?.category}/New`) }}>新增</Button></Typography.P>
                </>
            }
        }
    ]
    const {
        getAuthorisedValuesCategoryData,
    } = useAuthorisedValuesCategory({
        onFinish: ({ axiosMode, status, values }) => {
        },
        onBefore: ({ axiosMode, values }) => { }
    })
    const {
        setOrders,
        custom_filter_key,
    } = useProTableOt({
        columns
    })
    return (
        <Row>
            <Col span={24}>
                <Title>
                    {t("")}
                </Title>
            </Col>
            <Col span={24}>
                <ProTableOt
                    actionRef={actionRef}
                    columns={columns}
                    rowSelection={{}}
                    params={{ pageSize: 20, current: 1 }}
                    request={async (params, sort, filter) => {
                        // setAxiosMode("get")
                        //console.log("params", params)
                        let newParams = {
                        };
                        let order = setOrders(sort)
                        newParams = {
                            ...newParams,
                            order,
                            size: params.pageSize,
                            cur_page: params.current,
                            custom_filter_value: params.keyword ?? "",
                            keyword: params.keyword ?? "",
                            custom_filter_key: custom_filter_key,
                        };
                        newParams = setParamsFilter({
                            ...newParams,
                        });
                        return getAuthorisedValuesCategoryData({
                            ...newParams
                        })
                    }}
                    toolBarRender={() => {
                        return ([
                            <Button variant="outline"
                                onClick={() => { navigate('/library/backstage/authorized_values_management/New') }}
                            >{t('new_category')}</Button>,
                        ])
                    }}
                />
            </Col>
        </Row>
    )
}

const MainContainer = styled.div`
width: 100%;
display: flex;
-webkit-box-pack: center;
justify-content: space-around;
flex-direction: column;
-webkit-box-align: start;
align-items: center;
padding: 2em;
gap: 0.5em;
-webkit-flex-wrap: wrap;
`

const Title = styled.div`
text-align: left;
width: 100%;
font-size: 1.6em;
font-weight: 600;
`
const FlexBox = styled.div`
display: flex;
gap: 1em;
`

export default AuthorisedValues